export function mousedownOutside(element: HTMLElement, { callbackFunction, ignoreElements = [] }: { callbackFunction: CallbackFn, ignoreElements?: HTMLElement[] }) {

  function onMousedown(event: MouseEvent) {

    if (event.target instanceof Element && !element.contains(event.target) && event.defaultPrevented === false) {
      if (ignoreElements.length) {
        for (let i = 0; i < ignoreElements.length; i++) {
          if (ignoreElements[i].contains(event.target)) {
            return;
          }
        }
      }
      callbackFunction(event.target);
    }
  }

  requestAnimationFrame(() => {
    document.body.addEventListener('mousedown', onMousedown, false);
  });

  return {
    update({ callbackFunction, ignoreElements = [] }: { callbackFunction: CallbackFn, ignoreElements?: HTMLElement[] }) {
      callbackFunction = callbackFunction;
    },
    destroy() {
      document.body.removeEventListener('mousedown', onMousedown, false);
    }
  }
}